module.exports = __webpack_public_path__ + "static/media/ring_tone.ea6a3bf1.mp3";